export const LIB_VERSION = '16.2.0'; // autogenerated
//# sourceMappingURL=version.js.map